if ($('.featured-grid').length) {
    $(window).on('load resize', function () {
        resizeGridImg();
    });
    function resizeGridImg() {
        $('.featured-grid').each(function () {
            if ($(this).find('.js-getArticleHeight')) {
                $(this).find('.js-setGridImg').css('height', '0');
                let overlayHeight = $(this).find('.js-getArticleHeight').outerHeight()
                let setHeight = overlayHeight + 14;
                $(this).find('.js-setGridImg').css('height', setHeight);
            }
        });
    }
}